export * from './sidenav';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/sidenav/index.js
// module id = 319
// module chunks = 0